/* global L */

import classNames from "classnames";
import calculateAnchorOffset from "../../Utils/calculateAnchorOffset";

export const createMapElementVectorGridIcon = iconStyle => {
  const className = classNames("map-marker", "map-marker-informative");
  const iconSize = [iconStyle.width, iconStyle.height];

  const anchorPositions = calculateAnchorOffset(iconStyle);
  const { anchorTop, anchorLeft } = anchorPositions;
  const iconAnchor = [-anchorLeft, -anchorTop];

  return new L.Icon({
    iconUrl: iconStyle.image?.url,
    iconSize,
    iconAnchor,
    className,
    opacity: iconStyle.opacity
  });
};
